/* TONA - CUENTA (PR-100, 21/09) · el tic-tac de todas las cuentas regresivas de la página.
 *
 * Un solo reloj para todas, no uno por cuenta. Se frena con la pestaña escondida y se pone al
 * día al volver: si no, el navegador estrangula el timer de una pestaña de fondo y la cuenta
 * queda atrasada varios segundos.
 *
 * Cada cuenta trae del servidor `data-hasta` con el INSTANTE de destino en segundos (UTC).
 * Acá se le resta el reloj del que mira. Nunca viaja un «faltan N segundos» calculado en el
 * servidor, porque Shopify guarda las páginas en caché y ese número llega viejo.
 *
 * `data-hasta="0"` quiere decir que la fecha no se entendió: esa cuenta no se toca.
 *
 * ⚠️ La cuenta depende del reloj de la computadora del que mira. Con el reloj mal puesto, el
 * número está mal. Es así en cualquier cuenta regresiva del mundo y no tiene arreglo.
 */
(function () {
  if (window.tonaCuenta) return;

  var SEG = 1000;
  var reloj = null;

  /* La misma tabla que el comentario de snippets/tona-cuenta.liquid. Si cambia una, cambia la otra. */
  function partes(faltan, formato) {
    var d = Math.floor(faltan / 86400);
    var resto = faltan - d * 86400;
    var hDia = Math.floor(resto / 3600);
    var m = Math.floor((resto - hDia * 3600) / 60);
    var s = resto - hDia * 3600 - m * 60;
    var hTotal = Math.floor(faltan / 3600);

    var verD = false;
    var verH = true;
    var verS = true;

    if (formato === 'dhms') {
      verD = true;
    } else if (formato === 'hms') {
      verD = false;
    } else if (formato === 'hm') {
      verS = false;
      verD = faltan >= 86400;
    } else {
      verD = faltan >= 86400;
      verH = faltan >= 3600;
    }

    return {
      d: d,
      h: verD ? hDia : hTotal,
      m: m,
      s: s,
      verD: verD,
      verH: verH,
      verS: verS,
      primera: verD ? 'd' : verH ? 'h' : 'm'
    };
  }

  function dosDigitos(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function escribir(unidad, valor, visible, esPrimera) {
    if (!unidad) return;
    var n = unidad.querySelector('.tona-cuenta__n');
    if (n && n.textContent !== valor) n.textContent = valor;
    unidad.classList.toggle('is-oculta', !visible);
    unidad.classList.toggle('is-primera', !!esPrimera);
  }

  function esconder(el) {
    if (el && !el.hasAttribute('hidden')) el.setAttribute('hidden', '');
  }

  function terminar(cuenta) {
    if (cuenta.dataset.tonaFin === '1') return false;
    cuenta.dataset.tonaFin = '1';
    var que = cuenta.getAttribute('data-al-terminar') || 'texto';

    if (que === 'cero') return false;

    if (que === 'ocultar_seccion') {
      esconder(cuenta.closest('[data-tona-barra]') || cuenta);
      return true;
    }
    if (que === 'ocultar_bloque') {
      esconder(cuenta.closest('[data-tona-item]') || cuenta);
      return true;
    }
    /* 'texto': se va el reloj y queda el cartel final */
    var reloj_ = cuenta.querySelector('.tona-cuenta__reloj');
    esconder(reloj_);
    var textos = cuenta.querySelectorAll('.tona-cuenta__texto');
    for (var i = 0; i < textos.length; i++) esconder(textos[i]);
    var fin = cuenta.querySelector('.tona-cuenta__fin');
    if (fin) fin.removeAttribute('hidden');
    return true;
  }

  function tic() {
    var cuentas = document.querySelectorAll('[data-tona-cuenta]');
    if (!cuentas.length) return;
    var ahora = Math.floor(Date.now() / 1000);
    var cambioElAncho = false;

    for (var i = 0; i < cuentas.length; i++) {
      var c = cuentas[i];
      var hasta = parseInt(c.getAttribute('data-hasta'), 10);
      if (!hasta) continue; /* fecha que no se entendió: se deja como vino */

      var faltan = hasta - ahora;
      if (faltan <= 0) {
        faltan = 0;
        if (terminar(c)) cambioElAncho = true;
      }

      var p = partes(faltan, c.getAttribute('data-formato') || 'auto');
      var us = c.querySelectorAll('.tona-cuenta__u');
      for (var j = 0; j < us.length; j++) {
        var u = us[j];
        var cual = u.getAttribute('data-u');
        if (cual === 'd') escribir(u, dosDigitos(p.d), p.verD, p.primera === 'd');
        else if (cual === 'h') escribir(u, dosDigitos(p.h), p.verH, p.primera === 'h');
        else if (cual === 'm') escribir(u, dosDigitos(p.m), true, p.primera === 'm');
        else if (cual === 's') escribir(u, dosDigitos(p.s), p.verS, false);
      }
    }

    /* Si una cuenta se apagó, la barra de al lado tiene que volver a medirse */
    if (cambioElAncho) {
      document.dispatchEvent(new CustomEvent('tona:cuenta-cambio'));
    }
  }

  function arrancar() {
    parar();
    tic();
    if (!document.hidden) reloj = setInterval(tic, SEG);
  }

  function parar() {
    if (reloj) {
      clearInterval(reloj);
      reloj = null;
    }
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) parar();
    else arrancar();
  });

  document.addEventListener('shopify:section:load', arrancar);

  window.tonaCuenta = { reescanear: tic, arrancar: arrancar };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
